"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRecord = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(recordsContract, dataHash) {
    var res, owner, metadataHash, sigCount, irisScore, dataUri, timestamp;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return recordsContract.records.call(dataHash);

          case 2:
            res = _context.sent;
            owner = res[0];
            metadataHash = res[1];
            sigCount = res[2];
            irisScore = res[3];
            dataUri = res[4];
            timestamp = new Date(res[5] * 1000);
            return _context.abrupt("return", {
              owner: owner,
              metadataHash: metadataHash,
              sigCount: sigCount,
              irisScore: irisScore,
              dataUri: dataUri,
              timestamp: timestamp
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getRecord(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getAttestation = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(recordsContract, dataHash, attestator) {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", recordsContract.sigExists.call(dataHash, attestator));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getAttestation(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

exports.default = {
  getRecord: getRecord,
  getAttestation: getAttestation
};
module.exports = exports["default"];
//# sourceMappingURL=records.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@linniaprotocol/linnia-js/lib/records.js
// module id = 560
// module chunks = 0